import React from "react";

const Privacy = () => {
  return (
    <div className="privacy">
      <h2>개인정보 처리 방침 </h2>
      <div className="row">
        <div className="col">
          <p>
            한국예탁결제원은 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」
            및 「개인정보보호법」 등에 따라 정보주체의 개인정보 및 권익을
            보호하고 개인정보와 관련한 정보주체의 고충을 원활하게 처리할 수
            있도록 다음과 같은 방침을 두고 있습니다. 한국예탁결제원은 본 방침을
            개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할
            것입니다. Ο 본 방침은 2018년 9월 1일부터 시행됩니다.
          </p>
          <h2>1. 개인정보 현황 </h2>
          <p>
            ① 한국예탁결제원은 업무시스템 참가, 원활한 고객상담 등을 위한
            최소한의 범위 내에서 정보주체로부터의 동의에 따라 아래와 같은
            개인정보를 수집하여 처리하고 있습니다.
          </p>
          <h2>2. 개인정보의 제3자 제공에 관한 사항</h2>
          <p>
            한국예탁결제원은 원칙적으로 정보주체의 개인정보를 수집 · 이용
            목적으로 명시한 범위 내에서 처리하며, 다음의 경우를 제외하고는
            정보주체의 사전 동의 없이는 본래의 목적 범위를 초과하여 처리하거나
            제3자에게 제공하지 않습니다. ① 정보주체로부터 별도의 동의를 받는
            경우 ② 법률에 특별한 규정이 있는 경우 ③ 정보주체 또는 법정대리인이
            의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을
            수 없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체,
            재산의 이익을 위하여 필요하다고 인정되는 경우 ④ 통계작성 및 학술연구
            등의 목적을 위하여 필요한 경우로서 특정 개인을 알아 볼 수 없는
            형태로 개인정보를 제공하는 경우 ⑤ 개인정보를 목적 외의 용도로
            이용하거나 이를 제3자에게 제공하지 아니하면 다른 법률에서 정하는
            소관 업무를 수행할 수 없는 경우로서 보호위원회의 심의 · 의결을 거친
            경우 ⑥ 조약, 그 밖의 국제협정의 이행을 위하여 외국정보 또는
            국제기구에 제공하기 위하여 필요한 경우 ⑦ 범죄의 수사와 공소의 제기
            및 유지를 위하여 필요한 경우 ⑧ 법원의 재판업무 수행을 위하여 필요한
            경우 ⑨ 형 및 감호, 보호처분의 집행을 위하여 필요한 경우
          </p>
          <h2>3. 개인정보처리 위탁</h2>
          <p>
            ① 한국예탁결제원은 원활한 개인정보 업무처리를 위하여 개인정보
            처리업무를 위탁할 수 있습니다. ② 한국예탁결제원은 위탁계약 체결시
            관련 법령에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적 ·
            관리적 보호조치, 재위탁 및 제3자 제공의 제한, 수탁자에 대한 관리 ·
            감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고,
            수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. ③
            위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 공개하도록
            하겠습니다. ※ 위탁현황 세부내역은 홈페이지
            내“고객정보센터”->“이용안내”->“개인정보 처리업무 위탁현황”을 참고
            바랍니다.
          </p>
          <h2>4. 정보주체 및 법정대리인의 권리 · 의무 및 그 행사방법</h2>
          <p>
            가. 정보주체 및 정보주체의 법정대리인이나 위임을 받은 자 등 대리인은
            언제든지 다음의 개인정보보호 관련 권리를 행사할 수 있습니다.
            정보주체의 법정대리인이나 위임을 받은 자 등 대리인은 이 경우
            개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야
            합니다. ① 개인정보(영상정보처리기기(CCTV)의 영상정보(이하 ‘CCTV
            영상정보’)를 포함) 열람요구 ② 오류 등이 있을 경우 정정 요구 ③ 삭제
            요구 ④ 처리정지 요구 나. 정보주체 및 정보주체의 법정대리인이나
            위임을 받은 자 등 대리인은 다음과 같은 방법으로 해당 권리를 행사할
            수 있습니다.
          </p>
          <h2>5. 영상정보처리기기(CCTV)의 설치 · 운영</h2>
          <p>
            한국예탁결제원은 다음과 같이 영상정보처리기기를 설치 · 운영하고
            있습니다. 가. 설치목적 : 시설안전 및 화재예방 나. 설치내용 : 본원,
            전산센터, 각 지원 로비 등 339대 설치 다. 관리책임자 : 안전관리팀장
            라. 영상정보처리기기 운영내용 ① 촬영시간 : 24시간 촬영 ② 보관기간 -
            금고 내 구역 : 촬영일로부터 6개월 이내 - 금고 외 구역 : 촬영일로부터
            3개월
          </p>
          <h2>6. 개인정보의 파기</h2>
          <p>
            한국예탁결제원은 원칙적으로 개인정보 처리목적이 달성된 경우에는
            지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은
            다음과 같습니다. 가. 파기절차 정보주체가 입력한 정보는 목적 달성 후
            별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련
            법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로
            옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로
            이용되지 않습니다. 나. 파기기한 정보주체의 개인정보는 개인정보의
            보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에,
            개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그
            개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한
            것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다. 다.
            파기방법 ① 종이에 출력된 개인정보 : 소각, 파쇄 및 용해 등의 방법을
            사용하여 폐기 ② 전자적 파일 형태로 저장된 개인정보 : 기록을 재생할
            수 없는 기술적 방법을 사용하여 삭제
          </p>
          <h2>7. 개인정보의 안전성 확보 조치</h2>
          <p>
            한국예탁결제원은 개인정보(CCTV 영상정보 포함)에 대하여 다음과 같이
            안전성 확보에 필요한 기술적 · 관리적 및 물리적 조치를 하고 있습니다.
            가. 개인정보취급자의 최소화 및 교육 실시 개인정보를 취급하는 직원을
            지정하고 담당자에 한정하여 개인정보를 관리하고 개인정보취급자 교육을
            실시 시행하고 있습니다. 나. 정기적인 자체 감사 실시 개인정보 취급
            관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고
            있습니다. 다. 내부관리계획의 수립 및 시행 개인정보의 안전한 처리를
            위하여 내부관리계획을 수립하고 시행하고 있습니다. 라. 개인정보의
            암호화 정보주체의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고
            있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를
            암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을
            사용하고 있습니다. 마. 해킹 등에 대비한 기술적 대책 한국예탁결제원은
            해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기
            위하여 보안프로그램을 설치하고 주기적인 갱신 · 점검을 하며
            외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적 ·
            물리적으로 감시 및 차단하고 있습니다. 바. 개인정보에 대한 접근 제한
            개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경,
            말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고
            있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
            있습니다. 사. 접속기록의 보관 및 위변조 방지 개인정보처리시스템에
            접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이
            위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다. 아.
            문서보안을 위한 잠금장치 사용 개인정보가 포함된 서류, 보조저장매체
            등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다. 자. 비인가자에
            대한 출입 통제 개인정보를 보관하고 있는 물리적 보관 장소를 별도로
            두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다. 차. 기타 ①
            쿠키에 의한 개인정보 수집 한국예탁결제원은 이용자에 대한 정보를
            저장하고 수시로 찾아내는 '쿠키(cookie)'를 사용하지 않습니다. ②
            링크사이트 한국예탁결제원은 이용자께 다른 회사의 웹사이트 또는
            자료에 대한 링크를 제공할 수 있습니다. 이 경우 한국예탁결제원은
            외부사이트 및 자료에 대한 아무런 통제권이 없으므로 그로부터 제공받는
            서비스나 자료의 유용성에 대해 책임질 수 없으며 보증할 수 없습니다.
            한국예탁결제원 홈페이지가 포함하고 있는 링크를 클릭(click)하여 타
            사이트(site)의 페이지로 옮겨갈 경우 해당 사이트의 개인정보
            처리방침은 한국예탁결제원과 무관하므로 새로 방문한 사이트의 정책을
            검토해 보시기 바랍니다. ③ 게시물 한국예탁결제원은 귀하의 게시물을
            소중하게 생각하며 변조, 훼손, 삭제되지 않도록 최선을 다하여
            보호합니다. 그러나 다음의 경우는 예외적으로 명시적 또는 개별적 경고
            후 삭제 및 변경조치를 할 수 있습니다. - 스팸(spam)성 게시물 (예 :
            행운의 편지, 8억 메일, 특정사이트 광고 등) - 타인을 비방할 목적으로
            허위 사실을 유포하여 타인의 명예를 훼손하는 글 - 동의 없는 타인의
            신상공개, 한국예탁결제원의 저작권, 제 3자의 저작권 등 권리를
            침해하는 내용, 기타 게시판 주제와 다른 내용의 게시물 -
            한국예탁결제원은 바람직한 게시판 문화를 활성화하기 위하여 동의 없는
            타인의 신상 공개 시 특정부분을 삭제하거나 기호 등으로 수정하여
            게시할 수 있습니다. - 다른 주제의 게시판으로 이동 가능한 내용일 경우
            해당 게시물에 이동 경로를 밝혀 오해가 없도록 하고 있습니다. -
            근본적으로 게시물에 관련된 제반 권리와 책임은 작성자 개인에게
            있습니다. 또 게시물을 통해 자발적으로 공개된 정보는 보호받기
            어려우므로 정보 공개 전에 심사숙고하시기 바랍니다.
          </p>
          <h2>8. 개인정보 보호책임자</h2>
          <p>
            가. 한국예탁결제원은 개인정보 처리에 관한 업무를 총괄해서 책임지고,
            개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여
            아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <h2>9. 개인정보 열람청구</h2>
          <p>
            ① 정보주체는 개인정보보호법 제35조에 따른 개인정보의 열람청구를
            아래의 부서에 할 수 있습니다. 한국예탁결제원은 정보주체의 개인정보
            열람청구가 신속하게 처리되도록 노력하겠습니다.
          </p>
          <h2>10. 권익침해 구제방법</h2>
          <p>
            아래의 기관은 한국예탁결제원과는 별개의 기관으로서, 한국예탁결제원의
            자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다
            자세한 도움이 필요하시면 문의하여 주시기 바랍니다. 가. 개인정보
            침해신고센터 (한국인터넷진흥원 운영) ① 소관업무 : 개인정보 침해사실
            신고, 상담 신청 ② 홈페이지 : http://privacy.kisa.or.kr ③ 전화 :
            (국번없이) 118 ④ 주소 : (58324) 전라남도 나주시 진흥길 9
            한국인터넷진흥원 3층 개인정보침해신고센터 나. 개인정보
            분쟁조정위원회 (개인정보보호위원회 운영) ① 소관업무 : 개인정보
            분쟁조정신청, 집단분쟁조정 (민사적 해결) ② 홈페이지 :
            www.kopico.go.kr ③ 전화 : 1833-6972 ④ 주소 : (03171) 서울특별시
            종로구 세종대로209 정부서울청사 4층 개인정보 분쟁조정위원회 다.
            대검찰청 사이버수사과 : (국번없이)1301 (www.spo.go.kr) 라. 경찰청
            사이버안전국 : (국번없이)182 (http://cyberbureau.police.go.kr)
          </p>
          <h2>11. 개인정보 처리방침 변경</h2>
          <p>
            ① 본 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의
            추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터
            공지사항을 통하여 고지할 것입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
